import * as React from "react";
const SvgEmail = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 9"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 1.125C0 .827.126.54.351.33.577.119.881 0 1.2 0h9.6c.318 0 .624.119.848.33.226.21.352.497.352.795v6.75c0 .298-.126.585-.351.796-.225.21-.53.329-.849.329H1.2c-.318 0-.623-.119-.849-.33A1.09 1.09 0 0 1 0 7.876v-6.75Zm2.111 0L6 4.315l3.889-3.19H2.11Zm8.689.748L6.395 5.486a.624.624 0 0 1-.79 0L1.2 1.873v6.002h9.6V1.873Z"
    />
  </svg>
);
export default SvgEmail;
